import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Check localStorage first, default to DARK
    const saved = localStorage.getItem('ella-gold-theme');
    return saved || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('ella-gold-theme', theme);
    
    // Update document class
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(theme);
    document.body.classList.remove('light', 'dark');
    document.body.classList.add(theme);
    
    // Update CSS variables and body styles
    if (theme === 'light') {
      document.documentElement.style.setProperty('--bg-primary', '#F8F8F8');
      document.documentElement.style.setProperty('--bg-secondary', '#FFFFFF');
      document.documentElement.style.setProperty('--text-primary', '#1A1A1A');
      document.documentElement.style.setProperty('--text-secondary', '#666666');
      document.documentElement.style.setProperty('--border-color', 'rgba(0, 0, 0, 0.1)');
      document.body.style.backgroundColor = '#F8F8F8';
      document.body.style.color = '#1A1A1A';
    } else {
      document.documentElement.style.setProperty('--bg-primary', '#050505');
      document.documentElement.style.setProperty('--bg-secondary', '#0A0A0A');
      document.documentElement.style.setProperty('--text-primary', '#F8F8F8');
      document.documentElement.style.setProperty('--text-secondary', '#999999');
      document.documentElement.style.setProperty('--border-color', 'rgba(255, 255, 255, 0.1)');
      document.body.style.backgroundColor = '#050505';
      document.body.style.color = '#F8F8F8';
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const isDark = theme === 'dark';

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, isDark }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
